var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7664 2.05762C16.7664 2.05762 17.7664 3.06762 17.7664 5.08762V12.1376C17.7664 14.1276 16.3564 14.8976 14.6264 13.8576L13.3064 13.0576C13.0064 12.8776 12.5264 12.8776 12.2264 13.0576L10.9064 13.8576C9.17636 14.8976 7.76636 14.1276 7.76636 12.1376V5.08762C7.76636 3.06762 8.76636 2.05762 10.7664 2.05762H14.7664Z",
    stroke: "#2F50F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58636 5.04758C4.17636 5.61758 2.76636 7.71758 2.76636 11.9576V14.9876C2.76636 20.0376 4.76636 22.0576 9.76636 22.0576H15.7664C20.7664 22.0576 22.7664 20.0376 22.7664 14.9876V11.9576C22.7664 7.64758 21.3064 5.53758 17.7664 5.01758",
    stroke: "#2F50F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark2);
export default __webpack_public_path__ + "static/media/bookmark2.c8e1aeabb74f81f1b53a07862c1d2cb6.svg";
export { ForwardRef as ReactComponent };